import { http } from '../../../api'
const apiUrl = '/covid'
const covid = {
  namespaced: true,
  state: {
    dataList: [],
    currencyList: [],
    users: [],
    itemData: null
  },
  actions: {
    getData: ({ commit }, params) => {
      return http.get(apiUrl).then(res => {
        commit('setData', res.data.data)
      })
    },
    update: ({ commit }, params) => {
      return http.put(apiUrl + '/' + params.id, params).then(res => {
      })
    }
  },
  mutations: {
    setData (state, data) {
      state.itemData = data
    }
  }
}

export default covid
